import React, { useState } from "react"
import PropTypes from "prop-types"
import { FaVolumeUp, FaVolumeMute } from "react-icons/fa"
import ReactPlayer from "react-player"

import { years } from "../services/timelineService"

const sampleData = require("../fixtures/content.json")
function Music(props) {
  const [muted, setMuted] = useState(false)

  if (Object.values(sampleData.years[years[props.currentSegment]].music).length > 0) {
    const [
      musicName,
      musicLink,
      musicStartTime,
      musicCue,
      musicVideoUrl,
      musicVolume
    ] = Object.values(sampleData.years[years[props.currentSegment]].music)
    return (
      <div className='music-player__wrapper' key={`music-player-${props.currentSegment}-${musicLink}`}>
        <ReactPlayer
          url={
            musicLink.includes("youtube")
              ? `${musicLink}&t=${musicCue}`
              : musicLink
          }
          height={0}
          width={0}
          playing={props.musicPlaying}
          volume={parseFloat(musicVolume)}
          muted={muted}
        />
        {props.musicPlaying && (
          <>
            {musicVideoUrl ? (
              <a
                href={`${musicLink}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                {musicName}
              </a>
            ) : (
              <p>{musicName}</p>
            )}
            {muted ? (
              <FaVolumeMute onClick={() => setMuted(!muted)} />
            ) : (
              <FaVolumeUp onClick={() => setMuted(!muted)} />
            )}
          </>
        )}
      </div>
    )
  } else {
    return null
  }
}

Music.propTypes = {
  musicPlaying: PropTypes.bool.isRequired,
  currentSegment: PropTypes.number.isRequired,
}

export default Music
